import { IComponentController } from 'angular';
import { IFormulaireItemClass } from '../../../../../core/services/formulaire/formulaire-item.service';
import { IFormulaire, IFormulaireClass } from '../../../../../core/services/formulaire/formulaire.service';
import { IMonoOccurrence, IMonoOccurrenceOptions } from '../../../../../core/services/mono-occurrence.service';
import { IMultiOccurrenceOptions } from '../../../../../core/services/multi-occurrence.service';
import { IFormulaireItemSautDeLigneClass } from '../../../../../core/services/formulaire/formulaire-item-saut-de-ligne.service';
import { IFormulaireGroupeClass } from '../../../../../core/services/formulaire/formulaire-groupe.service';
import { IEcranDetailsResourcesEntite } from '../../../../../core/resources/ecran-details.resource';
import { IStateParamsService, IStateService } from 'angular-ui-router';
import { IFormulaireItemSautDeColonneClass } from '../../../../../core/services/formulaire/formulaire-item-saut-de-colonne.service';

interface IPageAl2004 extends IComponentController {
    monoOccurrence: IMonoOccurrence;
    monoOccurrenceOptions: IMonoOccurrenceOptions;
    dhhMultiOccurrenceOptions: IMultiOccurrenceOptions;
    formulaireCriteres: IFormulaire;
}

/* @ngInject */
export default function Al2004Controller(
    Formulaire: IFormulaireClass,
    $state: IStateService,
    FormulaireItemSautDeColonne: IFormulaireItemSautDeColonneClass,
    ecranDetails: IEcranDetailsResourcesEntite,
    FormulaireGroupe: IFormulaireGroupeClass,
    FormulaireItem: IFormulaireItemClass,
    $stateParams: IStateParamsService,
    FormulaireItemSautDeLigne: IFormulaireItemSautDeLigneClass
) {
    const vm: IPageAl2004 = this;


    vm.formulaireDHD =
        new Formulaire('LBL_HOR', [
            new FormulaireGroupe('', new Formulaire([
                new FormulaireItem('aftcleint', { largeur: 95, resourceParams: (data: any) => ({ dlhcleint: data.dlhcleint }) }),
                new FormulaireItemSautDeLigne(),
                new FormulaireItem('vaesysjrssem', {
                    largeur: 50
                }),
                new FormulaireItemSautDeLigne(),
                new FormulaireItem('dhddursem'),
                new FormulaireItemSautDeLigne(),
                new FormulaireItem('dlhdatvig'),
            ]), { largeur: 50 }),
            new FormulaireGroupe('', new Formulaire([
                new FormulaireItem('dhdqtetra', {
                    largeur: 33
                }),
                new FormulaireItemSautDeLigne(),
                new FormulaireItem('dhdqteabs', {
                    largeur: 15
                }),
                new FormulaireItemSautDeLigne(),
                new FormulaireItem('totqte', {
                    largeur: 33
                }),
                new FormulaireItemSautDeLigne(),                
                new FormulaireItem('prctra', {
                    largeur: 33
                }),
                new FormulaireItem('dlhcleint', { default: $stateParams.dlhcleint }),

            ]), { largeur: 50 })
        ]);

    vm.monoOccurrenceOptions = {
        formulaire: vm.formulaireDHD,
        fonctions: {
            edition: ecranDetails.valeurs.flgiud,
            nouveau: ecranDetails.valeurs.flgiud,
            supprime: ecranDetails.valeurs.flgiud
        },
        reloadPage: true,
        successActionSauvegarde: () => {
            setTimeout(() => {
                $state.reload()
            }, 500);
        },
    }

    // Detail Horaire du dossier d'absence
    vm.dhhMultiOccurrenceOptions = {
        bloc: 'dhh',
        successActionSauvegarde: () => {
            setTimeout(() => {
                $state.reload()
            }, 500);
        },
        fonctions: {
            edition: ecranDetails.valeurs.flgiud,
            nouveau: ecranDetails.valeurs.flgiud,
            supprime: ecranDetails.valeurs.flgiud,
            editionRapide: true,
        },
        colonnesEnteteTitre: {
            ent_jrs1: [
                'actcod1', 'dhhqtetrajr1', 'dhhqteabsjr1', //Colonnes visibles
                'actcleintjr1', 'dhhqtetrajr1', 'dhhqteabsjr1' //Colonnes du mode édition
            ],
            ent_jrs2: [
                'actcod2', 'dhhqtetrajr2', 'dhhqteabsjr2', //Colonnes visibles
                'actcleintjr2', 'dhhqtetrajr2', 'dhhqteabsjr2'//Colonnes du mode édition
            ],
            ent_jrs3: [
                'actcod3', 'dhhqtetrajr3', 'dhhqteabsjr3', //Colonnes visibles
                'actcleintjr3', 'dhhqtetrajr3', 'dhhqteabsjr3'//Colonnes du mode édition
            ],      
            ent_jrs4: [
                'actcod4', 'dhhqtetrajr4', 'dhhqteabsjr4', //Colonnes visibles
                'actcleintjr4', 'dhhqtetrajr4', 'dhhqteabsjr4'//Colonnes du mode édition
            ],
            ent_jrs5: [
                'actcod5', 'dhhqtetrajr5', 'dhhqteabsjr5', //Colonnes visibles
                'actcleintjr5', 'dhhqtetrajr5', 'dhhqteabsjr5' //Colonnes du mode édition
            ],
            ent_jrs6: [
                'actcod6', 'dhhqtetrajr6', 'dhhqteabsjr6', //Colonnes visibles
                'actcleintjr6', 'dhhqtetrajr6', 'dhhqteabsjr6' //Colonnes du mode édition
            ],
            ent_jrs7: [
                'actcod7', 'dhhqtetrajr7', 'dhhqteabsjr7', //Colonnes visibles
                'actcleintjr7', 'dhhqtetrajr7', 'dhhqteabsjr7' //Colonnes du mode édition
            ],  
        },
        entetesReplacedValues: {
            ent_jrs1: ecranDetails.valeurs.entjrs1,
            ent_jrs2: ecranDetails.valeurs.entjrs2,
            ent_jrs3: ecranDetails.valeurs.entjrs3,
            ent_jrs4: ecranDetails.valeurs.entjrs4,
            ent_jrs5: ecranDetails.valeurs.entjrs5,
            ent_jrs6: ecranDetails.valeurs.entjrs6,
            ent_jrs7: ecranDetails.valeurs.entjrs7
        },
        colonnesVisibles: [
            { nom: 'dhhnumsem', largeur: 70 },
            { nom: 'actcod1', largeur: 80 },
            { nom: 'dhhqtetrajr1', largeur: 75 },
            { nom: 'dhhqteabsjr1', largeur: 75 },
            { nom: 'actcod2', largeur: 80 },
            { nom: 'dhhqtetrajr2', largeur: 75 },
            { nom: 'dhhqteabsjr2', largeur: 75 },
            { nom: 'actcod3', largeur: 80 },
            { nom: 'dhhqtetrajr3', largeur: 75 },
            { nom: 'dhhqteabsjr3', largeur: 75 },
            { nom: 'actcod4', largeur: 80 },
            { nom: 'dhhqtetrajr4', largeur: 75 },
            { nom: 'dhhqteabsjr4', largeur: 75 },
            { nom: 'actcod5', largeur: 80 },
            { nom: 'dhhqtetrajr5', largeur: 75 },
            { nom: 'dhhqteabsjr5', largeur: 75 },
            { nom: 'actcod6', largeur: 80 },
            { nom: 'dhhqtetrajr6', largeur: 75 },
            { nom: 'dhhqteabsjr6', largeur: 75 },
            { nom: 'actcod7', largeur: 80 },
            { nom: 'dhhqtetrajr7', largeur: 75 },
            { nom: 'dhhqteabsjr7', largeur: 75 }
        ],
        colonnesCachees: [
            'dlhcleint',
            'dhhcleint',
            'dhdcleint',
        ],
        colonnesEditionRapide: [
            { nom: 'dhhnumsem', largeur: 70 },
            { nom: 'actcleintjr1', largeur: 200 },
            { nom: 'dhhqtetrajr1', largeur: 75 },
            { nom: 'dhhqteabsjr1', largeur: 75 },
            { nom: 'actcleintjr2', largeur: 200 },
            { nom: 'dhhqtetrajr2', largeur: 75 },
            { nom: 'dhhqteabsjr2', largeur: 75 },
            { nom: 'actcleintjr3', largeur: 200 },
            { nom: 'dhhqtetrajr3', largeur: 75 },
            { nom: 'dhhqteabsjr3', largeur: 75 },
            { nom: 'actcleintjr4', largeur: 200 },
            { nom: 'dhhqtetrajr4', largeur: 75 },
            { nom: 'dhhqteabsjr4', largeur: 75 },
            { nom: 'actcleintjr5', largeur: 200 },
            { nom: 'dhhqtetrajr5', largeur: 75 },
            { nom: 'dhhqteabsjr5', largeur: 75 },
            { nom: 'actcleintjr6', largeur: 200 },
            { nom: 'dhhqtetrajr6', largeur: 75 },
            { nom: 'dhhqteabsjr6', largeur: 75 },
            { nom: 'actcleintjr7', largeur: 200 },
            { nom: 'dhhqtetrajr7', largeur: 75 },
            { nom: 'dhhqteabsjr7', largeur: 75 },
        ],
        formulaire: new Formulaire([
            new FormulaireItem('dhhnumsem', { largeur: 5 }),
            new FormulaireItemSautDeLigne(),
            new FormulaireItem('actcleintjr1', { largeur: 29, titre: ecranDetails.valeurs.entjrs1 + ' - Code de Temps' }),
            new FormulaireItem('dhhqtetrajr1', { largeur: 15, titre: ecranDetails.valeurs.entjrs1 + ' - Qté travaillée' }),
            new FormulaireItem('dhhqteabsjr1', { largeur: 15, titre: ecranDetails.valeurs.entjrs1 + ' - Qté absence' }),
            new FormulaireItemSautDeLigne(),
            new FormulaireItem('actcleintjr2', { largeur: 29, titre: ecranDetails.valeurs.entjrs2 + ' Temps' }),
            new FormulaireItem('dhhqtetrajr2', { largeur: 15, titre: ecranDetails.valeurs.entjrs2 + ' - Qté travaillée' }),
            new FormulaireItem('dhhqteabsjr2', { largeur: 15, titre: ecranDetails.valeurs.entjrs2 + ' - Qté absence' }),
            new FormulaireItemSautDeLigne(),
            new FormulaireItem('actcleintjr3', { largeur: 29, titre: ecranDetails.valeurs.entjrs3 + ' - Code de Temps' }),
            new FormulaireItem('dhhqtetrajr3', { largeur: 15, titre: ecranDetails.valeurs.entjrs3 + ' - Qté travaillée' }),
            new FormulaireItem('dhhqteabsjr3', { largeur: 15, titre: ecranDetails.valeurs.entjrs3 + ' - Qté absence' }),
            new FormulaireItemSautDeLigne(),
            new FormulaireItem('actcleintjr4', { largeur: 29, titre: ecranDetails.valeurs.entjrs4 + ' - Code de Temps' }),
            new FormulaireItem('dhhqtetrajr4', { largeur: 15, titre: ecranDetails.valeurs.entjrs4 + ' - Qté travaillée' }),
            new FormulaireItem('dhhqteabsjr4', { largeur: 15, titre: ecranDetails.valeurs.entjrs4 + ' - Qté absence' }),
            new FormulaireItemSautDeLigne(),            
            new FormulaireItem('actcleintjr5', { largeur: 29, titre: ecranDetails.valeurs.entjrs5 + ' - Code de Temps' }),
            new FormulaireItem('dhhqtetrajr5', { largeur: 15, titre: ecranDetails.valeurs.entjrs5 + ' - Qté travaillée' }),
            new FormulaireItem('dhhqteabsjr5', { largeur: 15, titre: ecranDetails.valeurs.entjrs5 + ' - Qté absence' }),            
            new FormulaireItemSautDeLigne(),
            new FormulaireItem('actcleintjr6', { largeur: 29, titre: ecranDetails.valeurs.entjrs6 + ' - Code de Temps' }),
            new FormulaireItem('dhhqtetrajr6', { largeur: 15, titre: ecranDetails.valeurs.entjrs6 + ' - Qté travaillée' }),
            new FormulaireItem('dhhqteabsjr6', { largeur: 15, titre: ecranDetails.valeurs.entjrs6 + ' - Qté absence' }),
            new FormulaireItemSautDeLigne(),
            new FormulaireItem('actcleintjr7', { largeur: 29, titre: ecranDetails.valeurs.entjrs7 + ' - Code de Temps' }),
            new FormulaireItem('dhhqtetrajr7', { largeur: 15, titre: ecranDetails.valeurs.entjrs7 + ' - Qté travaillée' }),
            new FormulaireItem('dhhqteabsjr7', { largeur: 15, titre: ecranDetails.valeurs.entjrs7 + ' - Qté absence' })
        ])
    }

}
